import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { AnimatedElement } from "./AnimatedElement";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";

@engineComponent(ComponentTypes.DisplayObject)
export class AnimatedLogo extends AnimatedElement {
    constructor() {
        super();
    }

    public createByNode(node: Element) {
        super.createByNode(node);
    }

    public updateByNode(node: Element) {
        super.updateByNode(node);
    }

    public start(): void {
        super.start();
    }

    public stop(): void {
        super.stop();
    }

    public clone(): AnimatedLogo {
        const element: AnimatedLogo = new AnimatedLogo();
        element.style = this.style;
        element.position.x = this.position.x;
        element.position.y = this.position.y;
        element.scale.x = this.scale.x;
        element.scale.y = this.scale.y;
        element.visible = this.visible;
        element.childs = {};
        element.removeChildren();
        for (let key in this.childs) {
            element.childs[key] = this.childs[key].clone();
            element.addChild(element.childs[key]);
        }
        let container: PIXI.Container = new PIXI.Container();
        if (element.children != null) {
            while (element.children.length !== 0) {
                container.addChild(element.children[0]);
            }
        }
        element.addChild(container);
        element._positionOffset = this._positionOffset;
        element._rotationOffset = this._rotationOffset;
        element._scaleOffset = this._scaleOffset;
        element._rotationDuration = this._rotationDuration;
        element._scaleDuration = this._scaleDuration;
        element._timerRange = this._timerRange;
        element._positionRangeDuration = this._positionRangeDuration;
        element.start();
        element.markAsCloned();
        return element;
    }

    public animate(): void {
        super.animate();
    }

    public move(): void {
        super.move();
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/AnimatedLogo.ts
 **/